// extracted by mini-css-extract-plugin
module.exports = {"label":"payments_label__3Z4Yh","form":"payments_form__3lfCk","name":"payments_name__327CF"};